import { extend } from '@react-three/fiber';
import { TextGeometry } from 'three/examples/jsm/geometries/TextGeometry';
import { FontLoader } from 'three/examples/jsm/loaders/FontLoader';
import breylone from '../font/Breylone_Regular.json';
// console.log(breylone);
// V1
// https://medium.com/@zmommaerts/how-to-create-3d-text-in-react-three-fiber-a35376456a04

// https://www.dafont.com/breylone.font
// https://gero3.github.io/facetype.js/

// OR v2
// https://www.ilyameerovich.com/simple-3d-text-meshes-in-three-js/
export default function AddTextGeometry({
  text,
  color,
  emissiveColor,
  emissivePower,
}) {
  extend({ TextGeometry });

  const font = new FontLoader().parse(breylone);
  // console.log('font: ', font);

  // let text = 'Hello Font!';

  // threejs.org/docs/?q=meshStandardMaterial#api/en/materials/MeshStandardMaterial
  return (
    <mesh position={[-2, 1, 0]}>
      <textGeometry args={[text, { font, size: 1, height: 0.1 }]} />
      <meshStandardMaterial
        // attach={material}
        color={color}
        emissive={emissiveColor}
        emissiveIntensity={emissivePower}
      />
    </mesh>
  );
}
